import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerDetailParams, TypePostOwnerDetailResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 화주사 정보 상세 조회
 */
const usePostOwnerDetail = () => {
  const endPoint = '/api-owner/owner/detail';

  const postOwnerDetail = async (params: TypePostOwnerDetailParams) => {
    return axiosInstance
      .post<TypePostOwnerDetailResponse>(endPoint, {
        ...params,
      })
      .then((data) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOwnerDetail };
};

export default usePostOwnerDetail;

const ownerDetailResponse: TypePostOwnerDetailResponse = {
  data: {
    ownerId: 340,
    ownerCode: 'CU000340',
    ownerName: 'e2e-owner',
    zipCode: '10545',
    address: '경기도 김포시 김포한강9로 76',
    detailAddress: 'e2e 화주사 본사',
    ceoName: '홍길동',
    businessNumber: '1234567890',
    businessNumberChecked: true,
    corporateNumber: null,
    businessConditions: '도소매',
    businessCategory: '식품',
    tel: '02-1234-5678',
    fax: '',
    ownerType: '3PL',
    fulfillmentTypeFlag: true,
    deliveryTypeFlag: true,
    nfaReturnExchangeLinkYn: null,
    managerAccountLimit: 5,
    ownerManagerDetailDomainList: [
      {
        ownerManagerId: 1,
        ownerCode: 'CU000340',
        ownerLoginId: 'CU000340-master',
        ownerManagerName: '김대표',
        ownerManagerPosition: '대표',
        ownerManagerTel: '010-1111-2222',
        ownerManagerEmail: 'master@e2e-owner.com',
        userClass: 'MASTER',
      },
      {
        ownerManagerId: 2,
        ownerCode: 'CU000340',
        ownerLoginId: 'CU000340-manager1',
        ownerManagerName: '이담당',
        ownerManagerPosition: '과장',
        ownerManagerTel: '010-3333-4444',
        ownerManagerEmail: 'manager1@e2e-owner.com',
        userClass: 'NORMAL',
      },
      {
        ownerManagerId: 3,
        ownerCode: 'CU000340',
        ownerLoginId: 'CU000340-manager2',
        ownerManagerName: '박사원',
        ownerManagerPosition: '',
        ownerManagerTel: '010-5555-6666',
        ownerManagerEmail: '',
        userClass: 'NORMAL',
      },
    ],
  },
};

registerMockAPI<TypePostOwnerDetailResponse>({
  method: 'post',
  endpoint: '/api-owner/owner/detail',
  label: '화주사정보/화주사정보/상세조회',
  scenarios: [{ name: '정상 응답 — 담당자 3명', response: ownerDetailResponse }],
});
